import * as React from 'react';
export function doOnceDecorator(fn, context) {
  var result;
  return function () {
    if (fn) {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      result = fn.apply(context || this, args);
      // eslint-disable-next-line no-param-reassign
      fn = context = null;
    }
    return result;
  };
}
/** Оборачивает пользовательский коллбэк в useDoOnce обертку, если требуется */
export var useGetCallback = function useGetCallback(cb, triggerOnce) {
  var onceCb = doOnceDecorator(cb);
  return React.useMemo(function () {
    return triggerOnce ? onceCb : cb;
  }, [cb, onceCb, triggerOnce]);
};